import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/navbar.css";

export default function NavBar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => setOpen(!open);

  // Scroll or navigate depending on current route
  const handleNavClick = (target) => {
    setOpen(false);

    if (location.pathname === "/") {
      // Already on homepage → smooth scroll
      const el = document.querySelector(target);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    } else {
      // Navigate home + pass scroll target
      navigate("/", { state: { scrollTo: target } });
    }
  };

  const navItems = [
    { label: "Főoldal", href: "#hero" },
    { label: "Flotta", href: "#fleet" },
    { label: "GYIK", href: "#faq" },
    { label: "Kapcsolat", href: "#contact" },
  ];

  return (
    <nav className="navbar navbar-expand-lg navbar-main fixed-top">
      <div className="container d-flex justify-content-between align-items-center">
        {/* LEFT SIDE – NAV (DESKTOP) */}
        <div className="d-none d-lg-flex nav-links">
          {navItems.map((item, i) => (
            <button
              key={i}
              className="nav-btn"
              onClick={() => handleNavClick(item.href)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* MOBILE TOGGLER */}
        <button
          className={`navbar-toggler custom-toggler ${open ? "open" : ""}`}
          type="button"
          onClick={toggleMenu}
          aria-label="Menü váltása"
        >
          <span className="bar top-bar"></span>
          <span className="bar middle-bar"></span>
          <span className="bar bottom-bar"></span>
        </button>

        {/* LOGO (RIGHT SIDE) */}
        <button
          className="navbar-brand-custom logo-block"
          onClick={() => handleNavClick("#hero")}
        >
          <img
            src="/images/logo-transparent.webp"
            alt="Autókölcsönző Szolnok logó"
            className="navbar-logo"
          />
          <span className="logo-text">autokolcsonzoszolnok.hu</span>
        </button>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${open ? "show" : ""}`}>
        {navItems.map((item, i) => (
          <button
            key={i}
            className="mobile-menu-item"
            onClick={() => handleNavClick(item.href)}
          >
            {item.label}
          </button>
        ))}
      </div>
    </nav>
  );
}
